import React, { useEffect, useState } from "react";
import Reportselect from "./Reportselect";
import { analyticsBusoccupancyApi } from "../../services/AnalyticService";
// import DatePicker from "../../components/Form/DateRangePicker";
import Select from "react-select";
import { format } from "date-fns";
import { Spinner } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { searchshift } from "../../services/Reportservice";
import { searchroute } from "../../services/Reportservice";
import { CancelRequest } from "../../services/AxiosInstance";
import DebounceSearchInput from "../Constant/DebounceSearchInput";
import { PiExportBold } from "react-icons/pi";
import { busoccupancyreportdownload } from "../../services/Reportservice";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import { FaCalendarAlt } from "react-icons/fa";
import Pagination from "../Constant/Pagination";
import { getBusArrivalStatus } from "../../utilities";
import {
  addDays,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
} from "date-fns";
import ReactApexChart from "react-apexcharts";

// const MiniDonut = ({ percent = 0, count = 0 }) => {
//   const series = [percent, 100 - percent];

//   const options = {
//     chart: {
//       type: "donut",
//       width: 40,
//       height: 40,
//     },
//     labels: ["Occupied", "Remaining"],
//     colors: ["#5b3d1c", "#e0e0e0"],
//     stroke: { width: 0 },
//     dataLabels: { enabled: false },
//     plotOptions: {
//       pie: {
//         donut: {
//           size: "60%", // Reduced from 75% to make more room for center text
//           labels: {
//             show: true,
//             name: { show: false },
//             value: { show: false },
//             total: {
//               show: true,
//               showAlways: true,
//               label: "",
//               formatter: () => `${count}`,
//               fontSize: "10px", // Reduced font size for small chart
//               fontFamily: "Arial, sans-serif",
//               fontWeight: 700,
//               color: "#5b3d1c",
//               offsetY: -2, // Slight offset to center better
//             },
//           },
//         },
//       },
//     },
//     tooltip: {
//       custom: ({ seriesIndex }) => {
//         if (seriesIndex === 1) return "";
//         return `<div style="padding:6px;font-size:12px;">
//           <b>Occupied:</b> ${count} (${percent.toFixed(1)}%)
//         </div>`;
//       },
//     },
//     legend: { show: false },
//   };

//   return (
//     <div style={{ width: 40, height: 40 }}>
//       <ReactApexChart
//         options={options}
//         series={series}
//         type="donut"
//         width={40}
//         height={40}
//       />
//     </div>
//   );
// };
const Busoccupancyreport = () => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const defaultOption = { value: "7_days", label: "Last 7 Days" };
  const [selectedOption, setSelectedOption] = useState(defaultOption);
  const [loading, setLoading] = useState(false);
  const [excellLoading, setExcellLoading] = useState(false);
  const [data, setData] = useState([]);
  const [routeoption, setRouteoption] = useState([]);
  const [shiftoption, setShiftoption] = useState([]);
  const [selecetdroute, setSelectedroute] = useState(null);
  const [selectedshift, setSelectedshift] = useState(null);
  const [total, setTotal] = useState(0);
  const [error, setError] = useState("");
  const [param, setParam] = useState({
    start_date: format(subDays(new Date(), 7), "yyyy-MM-dd"),
    end_date: format(new Date(), "yyyy-MM-dd"),
    shift: "",
    query: "",
    route: "",
    page: "1",
    page_size: "10",
  });
  const getreport = () => {
    setLoading(true);
    analyticsBusoccupancyApi(param)
      .then((res) => {
        setData(res?.data?.results || []);
        setTotal(res?.data?.count || 0);
        setError("");
      })
      .catch((err) => {
        setError(
          err?.response?.data?.message ||
            err?.response?.data?.error ||
            "Try again later"
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };
  useEffect(() => {
    getreport();
  }, [param]);

  const options = [
    { value: "yesterday", label: "Yesterday" },
    { value: "7_days", label: "Last 7 Days" },
    { value: "15_days", label: "Last 15 Days" },
    { value: "30_days", label: "Last 30 Days" },
    { value: "last_month", label: "Last Month" },
    { value: "3_months", label: "Last 3 Months" },
    { value: "custom", label: "Custom Date" },
  ];
  useEffect(() => {
    searchshift()
      .then((res) => {
        setShiftoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
    searchroute()
      .then((res) => {
        setRouteoption(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  const handleSearchChange = (value) => {
    if (value.length > 0) CancelRequest();
    setParam((prev) => ({
      ...prev,
      query: value,
    }));
  };
  useEffect(() => {
    setParam({
      ...param,
      shift: selectedshift?.value || "",
      route: selecetdroute?.value || "",
      page: "1",
    });
  }, [selectedshift, selecetdroute]);
  const handleexport = () => {
    setExcellLoading(true);
    const newparam = { ...param, export: true };
    busoccupancyreportdownload(newparam)
      .then((res) => {
        const blob = new Blob([res.data], { type: "application/pdf" });
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement("a");
        a.href = url;
        a.download = "Busoccupancy-report.xlsx"; // set your desired filename
        a.click();

        window.URL.revokeObjectURL(url); // clean up
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setExcellLoading(false);
      });
  };
  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (!option) {
      setParam({ ...param, start_date: "", end_date: "", page: "1" });
      return;
    }
    let startDate,
      endDate = new Date();
    switch (option.value) {
      case "yesterday":
        startDate = subDays(new Date(), 1);
        endDate = startDate;
        break;
      case "7_days":
        startDate = subDays(new Date(), 7);
        break;
      case "15_days":
        startDate = subDays(new Date(), 15);
        break;
      case "30_days":
        startDate = subDays(new Date(), 30);
        break;
      case "last_month":
        startDate = startOfMonth(subMonths(new Date(), 1));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "3_months":
        startDate = startOfMonth(subMonths(new Date(), 3));
        endDate = endOfMonth(subMonths(new Date(), 1));
        break;
      case "custom":
        setShowDatePicker(true);
        return;
      default:
        return;
    }
    setShowDatePicker(false);
    setParam({
      ...param,
      start_date: format(startDate, "yyyy-MM-dd"),
      end_date: format(endDate, "yyyy-MM-dd"),
      page: "1",
    });
  };
  const handlePageChange = (page) => {
    setParam((prev) => ({
      ...prev,
      page: page.selected + 1,
    }));
  };
  return (
    <>
      <div className="row mb-3">
        <div className="col d-flex flex-column flex-md-row justify-content-between">
          <div>
            <span
              className="text-primary"
              style={{ fontSize: "1.3rem", fontWeight: "500" }}
            >
              Bus Occupancy Report
            </span>
            <ol className="breadcrumb breadcrumb-arrow mb-0">
              <li className="breadcrumb-item">
                <Link to="/dashboard">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Report
              </li>
            </ol>
          </div>
          <div className="d-flex gap-2 justify-content-center align-items-center">
            <div style={{ width: "300px" }}>
              <Reportselect />
            </div>
            <button
              className="btn btn-primary d-flex align-items-center gap-1 align-self-center"
              onClick={handleexport}
              disabled={excellLoading || data.length === 0}
              // style={{ height: "38px" }}
            >
              {" "}
              {excellLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <PiExportBold size={18} />
              )}
              Export
            </button>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="d-flex justify-content-between flex-column flex-md-row gap-2 px-4 py-3">
          <div className="d-flex flex-column flex-md-row gap-3">
            <div className="flex-fill flex-md-grow-0">
              <small>Search here</small>
              <DebounceSearchInput handleSearchChange={handleSearchChange} />
            </div>
            <div
              className="flex-fill flex-md-grow-0 w-md-auto"
              style={{ maxWidth: "250px" }}
            >
              <small>Select Route</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={routeoption}
                value={selecetdroute}
                onChange={setSelectedroute}
                isClearable
                placeholder="Select Route"
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
            <div className="flex-fill flex-md-grow-0">
              <small>Select Shift</small>
              <Select
                className="react-select"
                classNamePrefix="select"
                options={shiftoption}
                value={selectedshift}
                onChange={setSelectedshift}
                placeholder="Select Shift"
                isClearable
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
          <div className="d-flex flex-column flex-md-row gap-2">
            {showDatePicker && (
              <div className="flex-fill flex-md-grow-0">
                <small>Select Date</small>
                {/* <DatePicker
              onChange={handleDateChange}
              autoHide={true}
              todayBtn={true}
              clearBtn={true}
              format="yyyy/mm/dd"
              value={{
                startDate: param.start_date,
                endDate: param.end_date,
              }}
            /> */}
                {/* <FaCalendarAlt className="me-2" /> */}
                <DatePicker
                  selectsRange
                  startDate={
                    param?.start_date ? new Date(param.start_date) : null
                  }
                  endDate={param?.end_date ? new Date(param.end_date) : null}
                  onChange={(update) => {
                    const [start, end] = update;
                    setParam((prev) => ({
                      ...prev,
                      start_date: start ? format(start, "yyyy-MM-dd") : "",
                      end_date: end ? format(end, "yyyy-MM-dd") : "",
                      page: 1,
                    }));
                  }}
                  isClearable
                  placeholderText="Select date range"
                  className="form-control"
                  style={{
                    fontSize: "0.5rem",
                  }}
                  popperProps={{
                    modifiers: [
                      {
                        name: "zIndex",
                        enabled: true,
                        phase: "beforeWrite",
                        fn({ state }) {
                          state.styles.popper.zIndex = 999;
                        },
                      },
                    ],
                  }}
                />
              </div>
            )}
            <div className="flex-fill flex-md-grow-0">
              <small>Select Period</small>
              <Select
                options={options}
                onChange={handleSelectChange}
                placeholder="Select Period"
                className="react-select"
                classNamePrefix="select"
                value={selectedOption}
                styles={{
                  menu: (provided) => ({
                    ...provided,
                    zIndex: 999,
                  }),
                }}
              />
            </div>
          </div>
        </div>
        <div className="card-body p-0">
          <div>
            {loading ? (
              <div className="text-center my-3">
                <Spinner animation="border" />
              </div>
            ) : error ? (
              <div className="text-center text-danger my-3">{error}</div>
            ) : data?.length > 0 ? (
              <div className="table-responsive pb-1">
                <table class="table fs-6 align-middle">
                  <thead class="table-light custom-thead">
                    <tr>
                      <th scope="col">Date</th>
                      <th scope="col">Route</th>
                      <th scope="col">Shift</th>
                      <th scope="col">Bus</th>
                      <th scope="col">Capacity</th>
                      <th scope="col">Occupied</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.map((item) => {
                      const tripType = item?.trip_mode || "";
                      const badgeClass =
                        tripType.toLowerCase() === "pickup"
                          ? "bg-info"
                          : "bg-secondary";
                      const { className: statusClass, text: statusText } =
                        getBusArrivalStatus(item?.status);
                      return (
                        <tr>
                          <td scope="col">
                            {item?.date
                              ? format(item?.date, "dd MMM yyyy")
                              : "N/A"}
                          </td>
                          <td scope="col">
                            <div>
                              <span
                                className="text-primary fw-medium"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {item?.route?.name || "N/A"}
                              </span>
                            </div>
                          </td>
                          <td>
                            <span
                              className="text-dark fw-medium"
                              style={{ fontSize: "0.85rem" }}
                            >
                              {item?.shift?.name || "N/A"}
                            </span>
                          </td>
                          <td scope="col">
                            <div>
                              <span
                                className="text-primary fw-medium"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {item?.bus?.bus_number || "N/A"}
                              </span>
                            </div>
                          </td>
                          <td scope="col">{item?.actual_capacity || "N/A"}</td>
                          <td scope="col">
                            {/* <MiniDonut
                              percent={item?.utilization_percent || 0}
                              count={item?.employee_boarding_count || 0}
                            /> */}
                            {item?.employee_boarding_count ?? "N/A"} (
                            {item?.utilization_percent != null
                              ? `${item.utilization_percent}%`
                              : "N/A"}
                            )
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center my-3">No Data Found</div>
            )}
            {!loading && data.length > 0 && (
              <div className="px-2 py-1 border-top">
                <Pagination
                  currentPage={param.page}
                  recordsPage={param.page_size}
                  dataLength={total}
                  handlePagination={handlePageChange}
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Busoccupancyreport;
